import React, {useEffect, useState} from 'react'
import {fetchUserAccountDetailsAsync} from 'src/redux/actions/accountActions'
import {useAppDispatch, useAppSelector} from 'src/redux/storeHooks'
import {USER_DATA} from '../_interfaces/auth.interface'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faPen, faEyeSlash, faEye} from '@fortawesome/free-solid-svg-icons'

import Modal from 'react-bootstrap/Modal'
import {updateusernameAsync} from 'src/redux/actions/handelusernamechange'
import {getNotificationsSettingsAsync, updateNotificationsSettingsAsync, updatepasswordAsync} from 'src/redux/actions/passwordAction'
import useAppToast from 'src/hooks/useAppToast'
import Loader from 'src/utils/Loader'
import {Formik, Field, ErrorMessage} from 'formik'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {PasswordChangeType} from '../_interfaces/passwordChange.interface'
import {Button, Fade, OverlayTrigger, Spinner, Tab, Tabs} from 'react-bootstrap'
import {cancelSubscriptionAsync, getUserPlanAsync} from 'src/redux/actions/pricingActions'
import {UserSubscriptionPlan} from 'src/interfaces/Platform.interface'
import {format} from 'date-fns'
import CommonAlertModal from 'src/utils/modals/CommonAlertModal'
import BillingPlanDetail from './BillingPlanDetail'
import { Dropdown, Form,Alert,Card } from 'react-bootstrap';
import countries, { timezoneToCountryCode } from 'src/utils/CountryCodes'
import Tooltip from 'react-bootstrap/Tooltip';
import InfoTooltip from './listing/components/InfoTooltip'
import {generateMfaQrCodeAsync} from 'src/redux/actions/accountActions'
import { verifyMfaCodeAsync } from 'src/redux/actions/accountActions'
import { Form as FormikForm } from "formik"
import { useCustomerAccess } from 'src/hooks/useCustomerAccess'
import { shouldShowAction, getActionButtonProps, getFormFieldDisabled } from 'src/utils/customerAccessUtils'
import HistoryLogs from './history-logs/HistoryLogs'
import { loggedInAdminAccessToken } from 'src/utils/constants'
import NewHistoryLogs from './history-logs/NewHistoryLogs'
import AddManageUserFunctionality from './admin-panel/AddManageUserFunctionality'
import ManageRolesFunctionality from './admin-panel/ManageRolesFunctionality'

const initialValues = {
  previous_password: '',
  new_password: '',
  confirm_password: '',
}

const AccountSetting = () => {
  const dispatch = useAppDispatch()
  const {successToast, errorToast, warningToast} = useAppToast()
  const [show, setShow] = useState(false)
  const [show1, setShow1] = useState(false)
  const [showPhoneNumberPopUp, setShowPhoneNumberPopUp] = useState(false);
  const handlePhonePopUpClose = () => setShowPhoneNumberPopUp(false)
  const handlePhonePopUpOpen = () => setShowPhoneNumberPopUp(true)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const handleShownamemodal = () => setShow1(!show1)
  const [passwordVisible, setPasswordVisible] = useState(false) // State to track password visibility
  const [passwordVisible1, setPasswordVisible1] = useState(false)
  const [passwordVisible2, setPasswordVisible2] = useState(false)
  const [timezone, setTimezone] = useState('')
  const [gstNumber, setGstNumber] = useState('')
  const [companyName, setCompanyName] = useState('')
  const [prevPass, setPrevPass] = useState('')
  const [newPass, setNewPass] = useState('')
  const [confPass, setConfPass] = useState('')
  const {fetchedUserAccountLoading, fetchedUserAccountData, fetchedUserStaffData} = useAppSelector(
    (state) => state.userAccountData
  )
  const customerAccess = useCustomerAccess()
  const mfaEnablestatus = fetchedUserAccountData?.userAdditionalInfo?.mfa_enabled
  const [isSaving, setIsSaving] = useState(false) // State to track saving process
  const [userSubscribedPlan, setUserSubscriptionPlan] = useState<UserSubscriptionPlan>()
  const [userSubscribedPlanLoader, setUserSubscribedPlanLoader] = useState<boolean>(true)
  const {mainStoreData} = useAppSelector((state) => state.fetchConnectedPlatform)
  const [isCancelSubscriptionConfirm, setIsCancelSubscriptionConfirm] = useState<boolean>(false)
  const [isCanceling, setIsCanceling] = useState<boolean>(false)
  const [isNotifyOther, setIsNotifyOther] = useState(false)
  const [isUpdating, setIsUpdating] = useState(false)
  const [gstInputAlert, setGstInputAlert] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState<any>()
  const [selectedCountry, setSelectedCountry] = useState<any>();
  const [tempSelectedCountry, setTempSelectedCountry] = useState<any>({
      "name": "India",
      "code": "IN",
      "dial_code": "+91"
    });
  const [PhoneNumberPopUp, setPhoneNumberPopUp] = useState<any>()
  const [selectedCountryPopUp, setSelectedCountryPopUp] = useState<any>();
  const [searchQuery, setSearchQuery] = useState('');
 // mfa functionality states start
  const [mfamodal, setMFAmodal] = useState(false); // State to track saving process [setMFAmodal]
    const {qrCodeUrl, loading} = useAppSelector(
    (state) => state.mfaQrCode
  )
   const {verifyMfa, mfaverifyloading ,message} = useAppSelector(
    (state) => state.verifymfacode
  )
const [disableMfaModal, setDisableMfaModal] =useState(false)
const [mfaCode, setMfaCode] = useState('')
const [disablemfaCode, setdisableMfaCode] = useState("")
  const adminRoles = ['SUPERADMIN', 'Read access', 'All Access'];
  const isAdminAccess = adminRoles.includes( fetchedUserAccountData?.user_type as string );
  const isLoginAdminAcess = localStorage.getItem(loggedInAdminAccessToken);
 // mfa functionality states end

const [activeView, setActiveView] = useState<"users" | "roles">("users");
  const settingsPanelStyle = {
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
    color: 'rgb(51, 51, 51)',
    fontWeight: 600,
    fontSize: '1.1rem',
    backgroundColor: 'rgb(240, 242, 245)',
  } as const

  const passwordSchema = Yup.object({
    previous_password: Yup.string().required(' enter your previous password'),
    new_password: Yup.string()
      .min(8)
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])[a-zA-Z\d@$!%*?&.,]{8,}$/,
        // /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[a-zA-Z\d@$!%*?&]{8,}$/,
        'Use 8 or more characters with at least one uppercase letter, one lowercase letter, one special character, and one number'
      )
      .required('Password is required'),
    confirm_password: Yup.string()
      .oneOf([Yup.ref('new_password')], 'Passwords must match')
      .required('Confirm password is required'),
  })
  const [userData, setUserData] = useState<USER_DATA>()
  const [name, setName] = useState<string>(userData?.name || '')
  useEffect(() => {
    // Dispatch the fetch user data action on component mount
    dispatch(fetchUserAccountDetailsAsync())
      .then((response) => {
        setUserData(response.payload)
        const phoneNumber = response.payload.userAdditionalInfo?.phone_number;
        const digitsOnly = phoneNumber.replace(/\D/g, ''); 
        const last10Digits = digitsOnly.slice(2);
        setPhoneNumberPopUp(last10Digits)
  
        setPhoneNumber(last10Digits)
        const data = response.payload;
        setSelectedCountry(
          countries.find(
            (c) => c.name.toUpperCase() === data?.userAdditionalInfo?.country?.toUpperCase()
          )
        )
        setSelectedCountryPopUp(
          countries.find(
            (c) => c.name.toUpperCase() === data?.userAdditionalInfo?.country?.toUpperCase()
          )
        )
      })
      .catch((error) => {
        console.error('Error fetching user data:', error)
      })

    // dispatch(getUserPlanAsync()).then((response) => {
    //   if (response?.payload?.data?.billing_plan) {
    //     setUserSubscriptionPlan(response.payload?.data)
    //   }
    //   setUserSubscribedPlanLoader(false)
    // })
  }, [])  

  const handleChangeName = (e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value)
  }

  const handleChangeCompanyName = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCompanyName(e.target.value)
  }

  const handleChangeGstNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
    setGstNumber(e.target.value)
  }

  const notificationFormData = useFormik({
    initialValues:{
      isNotifyEmail:false,
      isNotifyStaff:false,
      isNotifyInventory:false,
      isNotifyOrders:false,
      isNotifyShipment:false,
      staff_list: fetchedUserAccountData?.email,
    },
    onSubmit: (values, helpers) => {
      if(fetchedUserAccountData?.id){
        dispatch(updateNotificationsSettingsAsync({user_id:fetchedUserAccountData?.id, payload:{ ...values} }))
        .then((response)=>{
          if(response.payload?.data?.id){
            successToast(response.payload?.message)
          }
          helpers.setSubmitting(false)
        })
        .catch((error) => {
          warningToast(error?.message+'')
          helpers.setSubmitting(false)
          
        })
      }
      
    }
  })

  useEffect(() => {
    if (fetchedUserAccountData?.name) {
      setName(fetchedUserAccountData?.name)
    }
    if(fetchedUserAccountData?.timezone){
      setTimezone(fetchedUserAccountData?.timezone)
    }
    if(fetchedUserAccountData?.gst_number){
      setGstNumber(fetchedUserAccountData?.gst_number)
    }
    if(fetchedUserAccountData?.company_name){
      setCompanyName(fetchedUserAccountData?.company_name)
    }

    if(fetchedUserAccountData?.id){
      dispatch(getNotificationsSettingsAsync({user_id:fetchedUserAccountData.id}))
      .then((res) =>{
        notificationFormData.setValues({
          isNotifyEmail:res.payload.user_settings?.isNotifyEmail || false,
          isNotifyStaff:res.payload.user_settings?.isNotifyStaff || false,
          isNotifyInventory:res.payload.user_settings?.isNotifyInventory || false,
          isNotifyOrders:res.payload.user_settings?.isNotifyOrders || false,
          isNotifyShipment:res.payload.user_settings?.isNotifyShipment || false,
          staff_list: res.payload.user_settings?.staff_list && !res.payload.user_settings?.staff_list.includes(fetchedUserAccountData?.email) ?  (fetchedUserAccountData?.email + ',' + res.payload.user_settings?.staff_list) : res.payload.user_settings?.staff_list
        })        
      })
      .catch((err)=>{
        console.log('error in getting notification settings', err);
      })
    }

  }, [fetchedUserAccountData])

  const sendusername = () => {
    if (name.trim() !== '' && companyName.trim() !== '') {
      const payload = {
        name,
        // timezone,
        companyName,
        phoneNumber: selectedCountry?.dial_code+phoneNumber,
        gstNumber,
        countryCode: selectedCountry?.code
      }
      setIsUpdating(true)
      dispatch(updateusernameAsync(payload)).then(async(response) => {
        setGstInputAlert(false)
        successToast('Changes saved successfully')
        await dispatch(fetchUserAccountDetailsAsync())
        setIsUpdating(false)
      })
      .catch(()=>{
        setIsUpdating(false)
      })
    } else {
      // Show an error toast or handle the case where the name and comapny name field is empty
      if (name.trim() === '') {
        errorToast('Name cannot be empty')
      } 
      if (companyName.trim() === '') {
        errorToast('Company name cannot be empty')
      }
      setIsUpdating(false)
    }
  }

  // if (fetchedUserAccountLoading || !fetchedUserAccountData) {
  //   return <div>Loading...</div>; // Render a loading state if data is being fetched or if data is not available yet
  // }
  const buttonStyle = {
    // padding: '2px 2px 2px 2px',
    fontSize: '12px',
    paddingTop: '2px',
    paddingBottom: '2px',
  }

  const formattedValidDate = userSubscribedPlan?.valid_till
    ? format(new Date(userSubscribedPlan?.valid_till), ' dd-MM-yyyy , hh:mm a')
    : '' // Handle null or undefined values

  const formattedActivateDate = userSubscribedPlan?.activated_on
    ? format(new Date(userSubscribedPlan?.activated_on), ' dd-MM-yyyy , hh:mm a')
    : ''

  const {values, errors, touched, handleBlur, handleChange, handleSubmit, isSubmitting} = useFormik(
    {
      initialValues,
      validationSchema: passwordSchema,
      onSubmit: (values, action) => {
        setIsSaving(true)
        try {
          dispatch(updatepasswordAsync(values)).then((response) => {
            setIsSaving(false)
            if (response?.payload?.status_code === 200) {
              successToast(response?.payload?.massage)
              handleClose()
            } else {
              errorToast(
                'Previous Password is incorrect. Please try again with the actual Password.'
              )
            }
          })
        } catch (e) {
          setIsSaving(false)
        }
        action.resetForm()
      },
    }
  )

  const validatePhoneNumber = (number: string): boolean => {
    if (!number) return false;
    const numericPhoneNumber = number.replace(/\D/g, '');
    return numericPhoneNumber.length >= 10 && numericPhoneNumber.length <= 13;
  };
const mfaenableChange = () => {
  if(
mfaEnablestatus

){
  setDisableMfaModal(true)

  }else{
    setMFAmodal(true) ;dispatch(generateMfaQrCodeAsync())
  }
}



const verifyMfafn = async (val) => {
  // console.log(fetchedUserAccountData, "data required for mfa")
// console.log(typeof val.mfaCode,"val type")
  try {
    const result = await dispatch(
      verifyMfaCodeAsync({ code: val.mfaCode, mfa_enabled: true })
    ).unwrap()
    setMFAmodal(false)
     await dispatch(fetchUserAccountDetailsAsync())
    successToast("2-Factor Authentication Enabled Successfully")
  } catch (err:any) {
    // console.log("yes error", err)
    errorToast(err.data?.massage)
  }
}





// ✅ Yup validation disabled schema
const DisableMfaSchema = Yup.object().shape({
  disablecode: Yup.string()
    .required("Authentication code is required")
    // .matches(/^[0-9]{6}$/, "OTP must be 6 digits"),
     .matches(/^[0-9]+$/, "Only numbers are allowed")
    .length(6, "Authentication code must be 6 digits"),
})
// Yup schema
const MfaSchema = Yup.object().shape({
  mfaCode: Yup.string()
    .required("Authentication code is required")
     .matches(/^[0-9]+$/, "Only numbers are allowed")
    .length(6, "Authentication code must be 6 digits"),
    // .matches(/^[0-9]{6}$/, "MFA code must be 6 digits"),
})
const disabledMfa =async (val)=> {
  // console.log(fetchedUserAccountData,"data required for mfa")
  // dispatch(verifyMfaCodeAsync({code:Number(disablemfaCode),mfa_enabled:false}))
  // if(!loading){
  //   // setMFAmodal(false)
  //   // toast.success('MFA Enabled Successfully')
  // }
    try {
    const result = await dispatch(
      verifyMfaCodeAsync({ code: val.disablecode, mfa_enabled: false })
    ).unwrap()
    setDisableMfaModal(false)
     await dispatch(fetchUserAccountDetailsAsync())
    successToast("2-Factor Authentication Disabled Successfully")
  } catch (err:any) {
    errorToast(err.data?.massage)
  }
}

useEffect(()=>{
  function findCountryByCode(countryCode) {
    return countries.find(country => country.code === countryCode) || {
      "name": "India",
      "code": "IN",
      "dial_code": "+91"
    };
  }

  let systemTimeZone;
  try {
    systemTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (e) {
    systemTimeZone = 'America/New_York';
  }

  const systemCountryCode = timezoneToCountryCode[systemTimeZone];

  const myCountry = findCountryByCode(systemCountryCode);

  setTempSelectedCountry(myCountry)
},[Intl.DateTimeFormat().resolvedOptions().timeZone])

  return (
    <>
      <style>{`
        .account-settings-card--local .tab-content {
          background: #ffffff;
          border-top: 0;
        }
      `}</style>
      <div className='card shadow-sm account-settings-card account-settings-card--local'>
        <div className='card-body p-0'>
      <Tabs
        defaultActiveKey='profileDetail'
        id='fill-tab-example'
        className='account-settings-tabs nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap px-5 pt-3'
      >
        <Tab
          eventKey='profileDetail'
          title='Profile Details'
          tabClassName='text-secondary'
          className='border-0'
        >
          <div className='row justify-content-center mx-0'>
            <div className=''>
              <div className='rounded border-0 p-4 m-4' style={settingsPanelStyle}>
                {fetchedUserAccountLoading ? (
                  <div
                    className='d-flex justify-content-center align-items-center'
                    style={{height: '50vh'}}
                  >
                    <Loader variant="section" />
                  </div>
                ) : (
                  <>
                    <div className="row mb-4 align-items-center">
                      <label
                        className="col-lg-4 col-form-label fw-semibold"
                        style={{ fontSize: '14px', color: '#495057' }}
                      >
                        Full Name <span className="text-danger">*</span>
                      </label>
                      <div className="col-lg-6">
                        <input
                          type="text"
                          className="form-control form-control-lg form-control-solid rounded"
                          placeholder="Enter your full name"
                          name="fName"
                          value={name}
                          onChange={handleChangeName}
                          style={{
                            border: '1px solid #ced4da', // default outline
                            transition: 'all 0.3s ease',
                          }}
                          onFocus={(e) => (e.target.style.border = '2px solid #0d6efd')}
                          onBlur={(e) => (e.target.style.border = '1px solid #ced4da')}
                        />
                      </div>
                    </div>
                    <div className="row mb-6">
                      <label
                        className="col-lg-4 col-form-label required fw-bold"
                        style={{ fontSize: '14px' }}
                      >
                        Email
                      </label>
                      <div className="col-lg-6">
                        <input
                          type="text"
                          className="form-control form-control-lg form-control-solid mb-3 mb-lg-0"
                          placeholder="Email"
                          value={fetchedUserAccountData?.email || ''}
                          disabled
                          readOnly
                          style={{
                            border: '1px solid #ced4da', // outline
                            borderRadius: '6px',
                            backgroundColor: '#e9ecef', // muted gray for disabled
                            color: '#6c757d', // muted text color
                          }}
                        />
                      </div>
                    </div>
                    <div className="row mb-6 align-items-center">
                      <label className="col-lg-4 col-form-label fw-bold" style={{ fontSize: '14px' }}>
                        Phone Number
                      </label>
                      <div className="col-lg-6 d-flex align-items-center gap-2">
                        {/* Country Dropdown */}
                        <Dropdown className="flex-shrink-0">
                          <Dropdown.Toggle
                            variant="light"
                            className="d-flex align-items-center gap-2"
                            style={{
                              minWidth: "130px",
                              height: "42px",
                              backgroundColor: "#e9ecef", // same as disabled email
                              border: "1px solid #ced4da",
                              color: selectedCountry ? "#212529" : "#6c757d",
                              pointerEvents: "none", // prevents hover effect since disabled
                            }}
                            disabled
                          >
                            {selectedCountry ? (
                              <>
                                <img
                                  src={`https://flagcdn.com/w40/${selectedCountry.code.toLowerCase()}.png`}
                                  alt={selectedCountry.code}
                                  width="20"
                                  height="15"
                                  style={{ borderRadius: "2px" }}
                                />
                                <span>{selectedCountry.dial_code}</span>
                              </>
                            ) : (
                              <>
                                {tempSelectedCountry && 
                                <>
                                  <img
                                    src={`https://flagcdn.com/w40/${tempSelectedCountry.code.toLowerCase()}.png`}
                                    alt={tempSelectedCountry.code}
                                    width="20"
                                    height="15"
                                    style={{ borderRadius: "2px" }}
                                  />
                                  <span>{tempSelectedCountry.dial_code}</span>
                                </>}
                              </>
                            )}
                          </Dropdown.Toggle>
                        </Dropdown>

                        {/* Phone Number Input */}
                        <input
                          type="number"
                          disabled
                          className="form-control form-control-lg form-control-solid flex-grow-1"
                          placeholder="Add Phone Number"
                          value={phoneNumber || ''}
                          readOnly
                          style={{
                            backgroundColor: "#e9ecef", // same as email
                            color: "#6c757d",
                            border: "1px solid #ced4da",
                            borderRadius: "6px",
                          }}
                        />

                        {/* Edit Button */}
                        {shouldShowAction(customerAccess, 'edit') && (() => {
                          const buttonProps = getActionButtonProps(customerAccess, 'edit')
                          return (
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={handlePhonePopUpOpen}
                            disabled={getFormFieldDisabled(customerAccess) || buttonProps.disabled}
                            title={buttonProps.title}
                            style={{ whiteSpace: 'nowrap', height: '42px', ...(buttonProps.style || {})}}
                          >
                            <i className="bi bi-pencil-fill me-1"></i> Edit
                          </button>
                          )
                        })()}
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label fw-bold' style={{fontSize: '14px'}}>
                        <span className='required'>Password:</span>
                      </label>
                      <div className='col-lg-6 d-flex align-items-center gap-2'>
                        <input
                          type='text'
                          disabled
                          className='form-control form-control-lg form-control-solid mb-0 flex-grow-1'
                          placeholder='Password'
                          name='password'
                          value={'**********'}
                          readOnly
                          style={{
                            backgroundColor: "#e9ecef",
                            color: "#6c757d",
                            border: "1px solid #ced4da",
                            borderRadius: "6px",
                          }}
                        />
                        {shouldShowAction(customerAccess, 'edit') && (() => {
                          const buttonProps = getActionButtonProps(customerAccess, 'edit')
                          return (
                          <button
                            className='btn btn-sm btn-primary'
                            onClick={handleShow}
                            disabled={getFormFieldDisabled(customerAccess) || buttonProps.disabled}
                            title={buttonProps.title}
                            style={{whiteSpace: 'nowrap', height: '42px', ...(buttonProps.style || {})}}
                          >
                            <i className="bi bi-pencil-fill me-1"></i> Edit
                          </button>
                          )
                        })()}
                      </div>
                    </div>
                    <div className="row mb-4 align-items-center">
                      <label
                        className="col-lg-4 col-form-label fw-semibold"
                        style={{ fontSize: '14px', color: '#495057' }}
                      >
                        <span>GST/VAT Number</span>
                      </label>
                      <div className="col-lg-6">
                        <input
                          type="text"
                          className="form-control form-control-lg form-control-solid rounded"
                          placeholder="GST/VAT Number"
                          name="gst number"
                          value={gstNumber}
                          maxLength={15}
                          onChange={handleChangeGstNumber}
                          style={{
                            border: '1px solid #ced4da', // default outline
                            transition: 'all 0.3s ease',
                          }}
                          onFocus={(e) => (e.target.style.border = '2px solid #0d6efd')}
                          onBlur={(e) => (e.target.style.border = '1px solid #ced4da')}
                        />
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label
                        className='col-lg-4 col-form-label required fw-bold'
                        style={{fontSize: '14px'}}
                      >
                        Company Name
                      </label>
                      <div className='col-lg-6'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                          placeholder='Company Name'
                          name='company name'
                          value={companyName}
                          onChange={handleChangeCompanyName}
                          style={{
                            border: '1px solid #ced4da', // default outline
                            transition: 'all 0.3s ease',
                          }}
                          onFocus={(e) => (e.target.style.border = '2px solid #0d6efd')}
                          onBlur={(e) => (e.target.style.border = '1px solid #ced4da')}
                        />
                      </div>
                    </div>
                       <div className='row align-items-center mb-6'>
                      <label
                        className='col-lg-4 col-form-label  fw-bold'
                        style={{fontSize: '14px'}}
                      >
                        Enable 2-Factor Authentication
                      </label>
                      <div className="col-7 p-0 ms-3  mb-3 mb-lg-0">
                      <div className='form-check form-switch form-check-custom form-check-solid'>
                        <input
                          className='form-check-input w-50px'
                          type='checkbox'
                          id='isMfaenable'
                          name='isMfaenable'
                          value={mfaEnablestatus}
                          checked={mfaEnablestatus}
                        onChange = {mfaenableChange}
                        />
                      </div>
                    </div>
                    </div>

                    {/* <div className='separator mt-3 '></div> */}
                    <div className='d-flex justify-content-end py-3 px-2'>
                      {fetchedUserAccountData?.role?.customer_access !== "RESTRICT" &&(
                      <button
                        onClick={sendusername}
                        type='submit'
                        className='btn btn-sm btn-primary fw-bold me-2'
                        disabled={fetchedUserAccountData?.role?.customer_access === "READ"}
                      >
                        { isUpdating ? 'Saving...' : 'Save Changes'}
                      </button>)}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </Tab>
        <Tab
          eventKey='emailNotifications'
          title='Notification Settings'
          tabClassName='text-secondary'
          className='border-0'
        >
          <div className='row justify-content-center mx-0'>
            <div className=''>
              <form onSubmit={notificationFormData.handleSubmit}>
                <div className='rounded border-0 h-100 p-4 m-4' style={settingsPanelStyle}>
                  <div className='row mb-6 align-items-center'>
                    <label className='col-lg-4 col-form-label fw-bold' htmlFor='isNotifyEmail'>
                      Email notification for any sync failure error{' '}
                      <InfoTooltip message='Enable notifications for various error-related events.' />
                    </label>
                    <div className='col-lg-6 p-0'>
                      <div className='form-check form-switch form-check-custom form-check-solid'>
                        <input
                          className='form-check-input w-50px'
                          type='checkbox'
                          id='isNotifyEmail'
                          name='isNotifyEmail'
                          checked={notificationFormData.values.isNotifyEmail}
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            ['isNotifyEmail', 'isNotifyInventory', 'isNotifyOrders', 'isNotifyShipment', 'isNotifyStaff'].forEach((field) =>
                              notificationFormData.setFieldValue(field, isChecked)
                            )
                          }}
                          onBlur={notificationFormData.handleBlur}
                        />
                      </div>
                    </div>
                  </div>
                  {notificationFormData.values?.isNotifyEmail ?
                    <div className='row mb-6'>
                      <div className='col-lg-6 p-0'>
                          <textarea placeholder='Add more emails here, separated by commas, to receive notifications.'
                          name='staff_list' 
                          value={notificationFormData.values.staff_list} 
                          onChange={notificationFormData.handleChange}
                          onBlur={notificationFormData.handleBlur} 
                          className='form-control mw-500px min-h-100px' 
                          />
                      </div>
                    </div>
                    : null}
                  <div className='d-flex justify-content-end py-3 px-2'>
                    {shouldShowAction(customerAccess, 'edit') && (() => {
                      const buttonProps = getActionButtonProps(customerAccess, 'edit')
                      return (
                      <button 
                        type='submit' 
                        className='btn btn-sm btn-primary fw-bold me-2'
                        disabled={notificationFormData.isSubmitting || getFormFieldDisabled(customerAccess) || buttonProps.disabled}
                        title={buttonProps.title}
                        style={buttonProps.style}
                      >
                        { notificationFormData.isSubmitting ? 'Saving...' : 'Save Changes'}
                      </button>
                      )
                    })()}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Tab>
          {( fetchedUserStaffData?.account_type === "ADMIN_STAFF" || localStorage.getItem(loggedInAdminAccessToken)) ? (
        <Tab
         eventKey='historylogs'
          title="Application Logs"
          tabClassName='inline-tab text-secondary'
          className='border-0'
        >
          <NewHistoryLogs />
        </Tab>
         ) : null} 

       {( fetchedUserStaffData?.account_type === "ADMIN_STAFF" || localStorage.getItem(loggedInAdminAccessToken) ||
          fetchedUserAccountData?.account_type === 'DIRECT' || fetchedUserStaffData?.account_type === "USER_STAFF" ) && 
          fetchedUserAccountData?.parent_user_role?.user_staff_management_access !== "RESTRICT" ? (
          <Tab
            eventKey='usermanagement'
            title="User Management"
            tabClassName='inline-tab text-secondary'
            className='border-0'
          >
            <div >
              {activeView === "users" ? (
                <AddManageUserFunctionality setActiveView={setActiveView} />
              ) : (
                <ManageRolesFunctionality setActiveView={setActiveView} />
              )}
            </div>
          </Tab>
        ) : null}

      </Tabs>
        </div>
      </div>

        <Modal show={showPhoneNumberPopUp} onHide={handlePhonePopUpClose}>
          <Modal.Header closeButton>
            <Modal.Title>Add/Change Phone Number</Modal.Title>
          </Modal.Header>

          <Modal.Body>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              const form = e.target as HTMLFormElement;
              const phoneInput = form.elements.namedItem('phone_number') as HTMLInputElement;
              const phone = phoneInput.value.trim();

              if (!validatePhoneNumber(phone)) {
                alert('Please enter a valid phone number (7 to 13 digits).');
                return;
              }

              setPhoneNumber(PhoneNumberPopUp);
              
              setSelectedCountry(selectedCountryPopUp)
              handlePhonePopUpClose();
            }}
          >
            <div className='input-block'>
              <label
                htmlFor='phone_number'
                className='input-label col-lg-4 col-form-label required fw-bold'
              >
                Add Phone Number
              </label>

              <div className='d-flex'>
                {/* Country Dropdown */}
                <Dropdown className='me-2'>
                  <Dropdown.Toggle
                    variant='outline-secondary'
                    className='d-flex align-items-center gap-2'
                    style={{ minWidth: '100px', height: '42px' }}
                  >
                    {selectedCountryPopUp ? (
                      <>
                        <img
                          src={`https://flagcdn.com/w40/${selectedCountryPopUp.code.toLowerCase()}.png`}
                          alt={selectedCountryPopUp.code}
                          width='20'
                        />
                        <span>{selectedCountryPopUp.dial_code}</span>
                      </>
                    ):
                    (
                      <>
                        {tempSelectedCountry && 
                        <>
                          <img
                            src={`https://flagcdn.com/w40/${tempSelectedCountry.code.toLowerCase()}.png`}
                            alt={tempSelectedCountry.code}
                            width="20"
                            height="15"
                            style={{ borderRadius: "2px" }}
                          />
                          <span>{tempSelectedCountry.dial_code}</span>
                        </>}
                      </>
                    )
                    }
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    style={{
                      maxHeight: '250px',
                      overflowY: 'auto',
                      overflowX: 'hidden',
                      minWidth: '260px',
                      boxShadow: '0 0.5rem 1rem rgba(0,0,0,0.15)',
                      borderRadius: '8px',
                      padding: '0.5rem'
                    }}
                  >
                    {/* Search Input */}
                    <Form.Control
                      type="text"
                      placeholder="Search country..."
                      className="mb-2"
                      style={{
                        padding: '0.375rem 0.75rem',
                        borderRadius: '6px',
                        fontSize: '0.9rem'
                      }}
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                    />

                    <div className="dropdown-divider mb-2" />

                    {/* Country List */}
                    {countries
                      .filter((c) =>
                        c.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                        c.code.toLowerCase().includes(searchQuery.toLowerCase()) ||
                        c.dial_code.includes(searchQuery)
                      )
                      .map((country) => (
                        <Dropdown.Item
                          key={country.code}
                          onClick={() => {
                            setSelectedCountryPopUp(country);
                            setSearchQuery('');
                          }}
                          className="d-flex align-items-center justify-content-between px-2 py-2 rounded"
                          style={{
                            fontSize: '0.875rem',
                            transition: 'background 0.2s',
                          }}
                        >
                          <div className="d-flex align-items-center gap-2">
                            <img
                              src={`https://flagcdn.com/w40/${country.code.toLowerCase()}.png`}
                              alt={country.code}
                              width="20"
                              height="15"
                              style={{ borderRadius: '2px' }}
                            />
                            <span>{country.dial_code} {country.name}</span>
                          </div>
                        </Dropdown.Item>
                      ))}

                    {/* No Results */}
                    {countries.filter((c) =>
                      c.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                      c.code.toLowerCase().includes(searchQuery.toLowerCase()) ||
                      c.dial_code.includes(searchQuery)
                    ).length === 0 && (
                      <div className="text-muted text-center py-2">No results found</div>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
                {/* Phone Number Input with Tooltip Validation */}
                <OverlayTrigger
                  placement="top"
                  trigger={['hover', 'focus']}
                  overlay={
                    <Tooltip>
                      Please enter a valid phone number.
                    </Tooltip>
                  }
                  show={!!phoneNumber && phoneNumber.length > 0 && !validatePhoneNumber(phoneNumber)}
                >
                  <input
                    className={`form-control ${!!phoneNumber && phoneNumber.length > 0 && !validatePhoneNumber(phoneNumber) ? 'is-invalid' : ''
                      }`}
                    type='text'
                    autoComplete='off'
                    name='phone_number'
                    id='phone_number'
                    placeholder='Enter Phone Number'
                    value={PhoneNumberPopUp}
                    onChange={(e) => setPhoneNumberPopUp(e.target.value.replace(/\D/g, ''))}
                    // style={{maxWidth:"100px"}}
                    maxLength={13}
                  />
                </OverlayTrigger>
              </div>
            </div>
            <div className='d-flex justify-content-end mt-6'>
              <Button variant='secondary' className='me-3' onClick={handlePhonePopUpClose}>
                Close
              </Button>
              <Button type='submit' disabled={isSubmitting || !validatePhoneNumber(PhoneNumberPopUp) || !selectedCountryPopUp}>
                {isSaving ? 'Saving' : 'Save'}
              </Button>
            </div>
          </form>
        </Modal.Body>
        </Modal>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <div className='input-block'>
              <label
                htmlFor='previous_password'
                className='input-label col-lg-4 col-form-label required fw-bold'
              >
                Previous Password
              </label>
              <div className='d-flex'>
                <input
                  className={`form-control ${
                    touched.previous_password && errors.previous_password ? 'is-invalid' : ''
                  }`}
                  type={passwordVisible ? 'text' : 'password'}
                  autoComplete='off'
                  name='previous_password'
                  id='previous_password'
                  placeholder=' Enter Previous Password'
                  value={values.previous_password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                <button
                  className='btn btn-outline-secondary'
                  type='button'
                  onClick={() => setPasswordVisible(!passwordVisible)}
                >
                  {passwordVisible ? (
                    <FontAwesomeIcon icon={faEye} />
                  ) : (
                    <FontAwesomeIcon icon={faEyeSlash} />
                  )}
                </button>
              </div>
              {errors.previous_password && touched.previous_password ? (
                <p className='form-error' style={{color: 'red'}}>
                  {errors.previous_password}
                </p>
              ) : null}
            </div>

            <div className='input-block'>
              <label
                htmlFor='new_password'
                className='input-label col-lg-4 col-form-label required fw-bold'
              >
                New Password
              </label>
              <div className='d-flex'>
                <input
                  className={`form-control ${
                    touched.new_password && errors.new_password ? 'is-invalid' : ''
                  }`}
                  type={passwordVisible1 ? 'text' : 'password'}
                  autoComplete='off'
                  name='new_password'
                  id='new_password'
                  placeholder=' Enter New Password'
                  value={values.new_password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <button
                  className='btn btn-outline-secondary'
                  type='button'
                  onClick={() => setPasswordVisible1(!passwordVisible1)}
                >
                  {passwordVisible1 ? (
                    <FontAwesomeIcon icon={faEye} />
                  ) : (
                    <FontAwesomeIcon icon={faEyeSlash} />
                  )}
                </button>
              </div>
              {errors.new_password && touched.new_password ? (
                <p className='form-error' style={{color: 'red'}}>
                  {errors.new_password}
                </p>
              ) : null}
            </div>

            <div className='input-block'>
              <label
                htmlFor='confirm_password'
                className='input-label col-lg-4 col-form-label required fw-bold'
              >
                Confirm Password
              </label>
              <div className='d-flex'>
                <input
                  className={`form-control ${
                    touched.confirm_password && errors.confirm_password ? 'is-invalid' : ''
                  }`}
                  type={passwordVisible2 ? 'text' : 'password'}
                  autoComplete='off'
                  name='confirm_password'
                  id='confirm_password'
                  placeholder=' Enter Confirm Password'
                  value={values.confirm_password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                <button
                  className='btn btn-outline-secondary'
                  type='button'
                  onClick={() => setPasswordVisible2(!passwordVisible2)}
                >
                  {passwordVisible2 ? (
                    <FontAwesomeIcon icon={faEye} />
                  ) : (
                    <FontAwesomeIcon icon={faEyeSlash} />
                  )}
                </button>
              </div>
              {errors.confirm_password && touched.confirm_password ? (
                <p className='form-error' style={{color: 'red'}}>
                  {errors.confirm_password}
                </p>
              ) : null}
            </div>
            <div className='d-flex justify-content-end mt-2'>
              <Button variant='secondary' className='me-3' onClick={handleClose}>
                Close
              </Button>
              <Button type='submit' disabled={isSubmitting}>
                {' '}
                {isSaving ? 'Saving' : 'Save'}
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
{loading ? <Spinner animation={'border'} style = {{position:"fixed",top:"50%",left:"50%"}}/>:<Modal 
centered =  {qrCodeUrl.length != 0 ?false:true}
backdrop="static"  show={mfamodal} onHide={() => setMFAmodal(false)}>
 <Modal.Header closeButton>
        <Modal.Title>🔐 2-Factor Authentication  {qrCodeUrl.length != 0 ?"Setup":null}</Modal.Title>
      </Modal.Header>
  <Modal.Body>

      {/* <Container className="d-flex align-items-center justify-content-center vh-100 bg-light"> */}
      {/* <Card
        className="p-4 shadow-lg rounded-4"
        style={{ maxWidth: "650px", width: "100%" }}
      > */}
        <Card.Body>
          {/* Page Heading */}
          {/* <h3 className="fw-bold mb-4">🔐 Multi-Factor Authentication Setup</h3> */}

          {/* Step 1 */}

  
          <div className="mb-4">
       {qrCodeUrl.length != 0 ?<> <h5 className="fw-semibold mb-2 ">1. Install a compatible app</h5>
            <p className="text-muted small mb-1">
              Install an authenticator app such as{" "}
              <strong>Google Authenticator</strong>,
              <strong> Microsoft Authenticator</strong> on your phone or computer.
            </p> </>:  <>   

                <Alert variant="success">
                 Note: You’ve already configured 2-Factor Authentication for your account. To enable 2-Factor Authentication enter code from authenticator app below.
              </Alert>
      </> }     
          </div>

          {/* Step 2 */}
          <div className="mb-4">
            {qrCodeUrl?.length != 0 ? <>           <h5 className="fw-semibold mb-2 text-left">2. Scan the QR Code</h5>
            <div className="text-center  d-flex align-items-center justify-content-center " >
          {loading ? <div
  className="text-center border rounded-3 p-2 shadow-sm my-2 d-flex align-items-center justify-content-center"
  style={{ width: "200px", height: "200px" }}
>
  <Loader variant="section" />
</div>
:  <img    style={{ width: "200px", height: "200px" }}
                src={qrCodeUrl}
                alt="QR Code"
                className="border rounded-3 p-2 shadow-sm my-2 "
              />}
            </div>
            <p className="text-muted small">
              Open your authenticator app, choose <strong>Scan QR code</strong>,
              and scan the image above. 
            </p></>:null}
 
 
          </div>
          {/* Step 3 */}

  <Formik
            initialValues={{ mfaCode: "" }}
            validationSchema={MfaSchema}
            onSubmit={(values, { setSubmitting }) => {
              verifyMfafn(values) // call your backend/API
              setSubmitting(false)
            }}
          >
            {({ isSubmitting }) => (
              <FormikForm>
                <div className="mb-3">
                  <h5 className="fw-semibold mb-2">{qrCodeUrl?.length != 0 ? "3." : ""} Enter 2-Factor Authentication code</h5>

                  <Form.Group className="mb-3" controlId="mfaCode">
                    <Field
                      as={Form.Control}
                      type="text"
                      name="mfaCode"
                      placeholder="Enter Authentication Code"
                      className="rounded-3"
                    />
                    <ErrorMessage name="mfaCode" component="div" className="text-danger mt-1" />
                  </Form.Group>

                  <Button
                    type="submit"
                    variant="primary"
                    className="w-100 rounded-3 fw-semibold"
                    style={{ padding: "10px 0" }}
                    disabled={isSubmitting}
                  >
                    Verify & Continue
                  </Button>
                </div>
              </FormikForm>
            )}
          </Formik>
        </Card.Body>
   
  </Modal.Body>
</Modal>} 

{/* maf disable modal  */}


 <Modal show={disableMfaModal} backdrop="static" onHide={() => setDisableMfaModal(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Disable 2-Factor Authentication</Modal.Title>
      </Modal.Header>

      <Formik
        initialValues={{ disablecode: "" }}
        validationSchema={DisableMfaSchema}
        onSubmit={(values, { setSubmitting }) => {
          disabledMfa(values) // your API call or action
          setSubmitting(false)
        }}
      >
        {({ isSubmitting }) => (
          <FormikForm>
            <Modal.Body>
              <Alert variant="danger">
                Warning: Disabling 2-Factor Authentication will remove an extra layer of protection from your account. Only proceed if you understand the risks.
              </Alert>

              <p>
                For security reasons, disabling 2-Factor Authentication requires authentication code verification. Please enter the authentication code from authenticator app to continue.
              </p>

              <Form.Group controlId="otpInput">
                <Form.Label>Enter authentication code</Form.Label>
                <Field name="disablecode" as={Form.Control} type="text" placeholder="Enter authentication code" />
                <ErrorMessage name="disablecode" component="div" className="text-danger mt-1" />
              </Form.Group>
            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary" className ="text-white bg-dark "onClick={() => setDisableMfaModal(false)}>
                Cancel
              </Button>
              <Button variant="danger" type="submit" disabled={isSubmitting}>
                Verify & Disable
              </Button>
            </Modal.Footer>
          </FormikForm>
        )}
      </Formik>
    </Modal>
      <CommonAlertModal
        title={
          fetchedUserAccountData?.source === 'WIX'
            ? `You have to cancel your current plan from Wix admin portal`
            : `Are you sure you want to cancel the Subscribed plan? The Plan will be downgraded to Free Forever plan.`
        }
        subtitle=''
        successDisabled={isCanceling}
        successBtnTitle={isCanceling ? 'Updating...' : 'Yes Confirm'}
        isTermsVisible={false}
        isVisible={isCancelSubscriptionConfirm}
        onCancel={() => {
          setIsCancelSubscriptionConfirm(false)
        }}
        onSuccess={() => {
          setIsCanceling(true)
          dispatch(
            cancelSubscriptionAsync({
              subscription_id: userSubscribedPlan?.subscription_id,
              platform_id: mainStoreData?.id,
            })
          ).then((response) => {
            if (response?.payload?.status_code === 201 && response?.payload?.data) {
              successToast(response?.payload?.message)
              setIsCanceling(false)
              setIsCancelSubscriptionConfirm(false)
              dispatch(getUserPlanAsync()).then((response) => {
                
                setUserSubscriptionPlan(response.payload?.data)
              })
            } else {
              errorToast(response?.payload?.message)
              setIsCanceling(false)
              setIsCancelSubscriptionConfirm(false)
              dispatch(getUserPlanAsync()).then((response) => {
                
                setUserSubscriptionPlan(response.payload?.data)
              })
            }
          })
        }}
      />
    </>
  )
}
export default AccountSetting
